<h2 mat-dialog-title class="tw-m-0 tw-text-lg tw-font-semibold">
  User object (gloss-api test state)
</h2>
<div mat-dialog-content class="tw-min-w-[min(90vw,52rem)]">
  <pre
    appGlossScroll
    class="tw-m-0 tw-text-xs tw-leading-relaxed tw-font-mono tw-max-h-[70vh] tw-overflow-auto tw-p-4 tw-bg-neutral-900 tw-text-dt-text-disabled tw-rounded-lg tw-whitespace-pre tw-break-normal gs-dark"
    >{{ data.json }}</pre
  >
</div>
<div mat-dialog-actions class="tw-flex tw-justify-end tw-gap-2">
  <button mat-stroked-button type="button" (click)="copyJson()">Copy</button>
  <button mat-button mat-dialog-close type="button">Close</button>
</div>
